var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.61289944,0.209704612 L8.70710678,0.292893219 L15.7071068,7.29289322 C15.7425008,7.32828727 15.774687,7.36567442 15.8036654,7.40469339 L15.8753288,7.5159379 L15.9287745,7.62866398 L15.9641549,7.73400703 L15.9930928,7.8819045 L16,8 L15.9972121,8.07523854 L15.9797599,8.20072576 L15.9502619,8.31214252 L15.9063266,8.42322155 L15.8540045,8.52070875 L15.7803112,8.62544899 L15.7071068,8.70710678 L8.70710678,15.7071068 C8.31658249,16.0976311 7.68341751,16.0976311 7.29289322,15.7071068 C6.93240926,15.3466228 6.90467972,14.7793918 7.20970461,14.3871006 L7.29289322,14.2928932 L12.585,9 L1,9 C0.44771525,9 0,8.55228475 0,8 C0,7.48716416 0.38604019,7.06449284 0.883378875,7.00672773 L1,7 L12.585,7 L7.29289322,1.70710678 C6.93240926,1.34662282 6.90467972,0.779391764 7.20970461,0.387100557 L7.29289322,0.292893219 C7.62333685,-0.0375504127 8.12750547,-0.0883878944 8.51140295,0.140380774 L8.61289944,0.209704612 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.62ec490abda6fb7376b93b11dc4fefe0.svg";
export { ForwardRef as ReactComponent };